import ls from 'store2'
// import Util from './index'
const permissions_all = [
  {
    name: 'global',
    label: '全局权限',
    show: true,
    items: [
      {
        name: 'global',
        label: '全局',
        items: [
          { name: 'globalSalePrice', desc: 'globalSalePriceDesc', label: '查看销售价、批发价', descc: '控制显示销售价、批发价' },
          { name: 'globalSupplier', desc: 'globalSupplierDesc', label: '查看供应商', descc: '查看供应商及共享的产品' },
          { name: 'globalCostPrice', desc: 'globalCostPriceDesc', label: '查看成本价', descc: '控制显示产品成本价、工序、配料' },
          { name: 'globalPurchasePrice', desc: 'globalPurchasePriceDesc', label: '查看采购价', descc: '控制采购单页面显示采购价' },
          { name: 'globalMaterialPrice', desc: 'globalMaterialPriceDesc', label: '查看物料仓单价', descc: '控制物料仓页面显示物料价格' }
        ]
      },

    ]
  },
  {
    name: 'dashboard',
    label: '工作台权限',
    show: true,
    items: [
      {
        name: 'dashboardOms',
        label: '订单',
        items: [
          { name: 'omsUserSales', desc: 'omsUserSalesDesc', label: '人员销售情况', descc: '' },
          { name: 'omsShopSales', desc: 'omsShopSalesDesc', label: '店铺销售情况', descc: '' },
          { name: 'omsWholeSales', desc: 'omsWholeSalesDesc', label: '批发客户销售情况', descc: '' },
          { name: 'omsOrderThead', desc: 'omsOrderTheadDesc', label: '七日销售趋势', descc: '' },
          { name: 'omsOrderTrack', desc: 'omsOrderTrackDesc', label: '订单跟单', descc: '' },
        ]
      },
      {
        name: 'dashboardPms',
        label: '采购',
        items: [
          { name: 'pmsSuplierPurchases', desc: 'pmsSuplierPurchasesDesc', label: '采购统计', descc: '' },
          { name: 'pmsPurchaseTrack', desc: 'pmsPurchaseTracksDesc', label: '采购跟单', descc: '' },
        ]
      },
      {
        name: 'dashboardWms',
        label: '库存',
        items: [
          { name: 'wmsWarehouse', desc: 'wmsWarehouseDesc', label: '库存情况', descc: '' },
          { name: 'wmsInventorySearch', desc: 'wmsInventorySearchDesc', label: '全库检索', descc: '' },
          { name: 'wmsInventorySearchSchedule', desc: 'wmsInventorySearchScheduleDesc', label: '查档期', descc: '' },
        ]
      },
      {
        name: 'dashboardMms',
        label: '物料',
        items: [
          { name: 'mmsMaterialWH', desc: 'mmsMaterialWHDesc', label: '物料库存', descc: '' },
          { name: 'mmsMaterialOnWay', desc: 'mmsMaterialOnWayDesc', label: '物料在途量', descc: '' },
          { name: 'mmsProductInquiryMaterial', desc: 'mmsProductInquiryMaterialDesc', label: '询料', descc: '' }
        ]
      },
      {
        name: 'dashboardMes',
        label: '生产',
        items: [
          { name: 'mesStatistic', desc: 'mesStatisticDesc', label: '生产统计', descc: '' },
          { name: 'mesTrack', desc: 'mesTrackDesc', label: '生产跟单', descc: '' },
          { name: 'mesDispersion', desc: 'mesDispersionDesc', label: '在产分布', descc: '' },
          { name: 'mesProduce', desc: 'mesProduceDesc', label: '扫描派发', descc: '' },
          { name: 'mesCalcExpectHandOver', desc: 'mesCalcExpectHandOverDesc', label: '排产预测', descc: '' },

        ]
      },
      {
        name: 'dashboardLms',
        label: '发货',
        items: [
          { name: 'lmsDeliveryCount', desc: 'lmsDeliveryCountDesc', label: '发货统计', descc: '' },
        ]
      },

    ]
  },
  {
    name: 'oms',
    label: '销售单管理',
    show: true,
    items: [
      {
        name: 'order',
        label: '销售单',
        items: [
          { name: 'orderView', desc: 'orderViewDesc', label: '订单查看', descc: '查询订单及查看订单详细' },
          { name: 'orderManage', desc: 'orderManageDesc', label: '订单管理', descc: '订单、订单项的新增、编辑、删除' },
          { name: 'orderConfirm', desc: 'orderConfirmDesc', label: '确认订单', descc: '确认订单' },
          { name: 'orderDeal-available', desc: 'orderDeal-availableDesc', label: '订单处理-现货', descc: '现货方式处理订单' },
          { name: 'orderDeal-manufacture', desc: 'orderDeal-manufactureDesc', label: '订单处理-生产', descc: '生产方式处理订单' },
          { name: 'orderDeal-purchase', desc: 'orderDeal-purchaseDesc', label: '订单处理-外采', descc: '外采方式处理订单' },
          { name: 'orderDeal-remake', desc: 'orderDeal-remakeDesc', label: '订单处理-改制', descc: '改制方式处理订单' },
          { name: 'orderDeal-reject', desc: 'orderDeal-rejectDesc', label: '订单处理-拒绝', descc: '拒绝客户下单' },
          { name: 'orderReminder', desc: 'orderReminderDesc', label: '订单催办', descc: '向后续订单协助处理催办' },
          { name: 'orderCancel', desc: 'orderCancelDesc', label: '订单取消', descc: '订单取消处理' },
          { name: 'orderReturn', desc: 'orderReturnDesc', label: '订单退货', descc: '订单退货处理' },
          { name: 'orderDistributiveOwner', desc: 'orderDistributiveOwnerDesc', label: '订单分配拥有人', descc: '分配订单给其他人' },
          { name: 'orderDealView', desc: 'orderDealViewDesc', label: '订单处理查看', descc: '查看订单后续处理的进度情况' },
          { name: 'orderLogView', desc: 'orderLogViewDesc', label: '订单日志查看', descc: '查看订单详细日志' },
          { name: 'orderRemindered', desc: 'orderReminderedDesc', label: '客户催单处理', descc: '查看客户的催单情况' },
          { name: 'orderPaymentView', desc: 'orderPaymentViewDesc', label: '查看收款/退款', descc: '查看订单的收款或退款' },
          { name: 'orderAddPayment', desc: 'orderAddPaymentDesc', label: '收款/退款', descc: '给订单添加收款或退款' },
          { name: 'orderAsyncPdm', desc: 'orderAsyncPdmDesc', label: '订单同步产品中心', descc: '订单项查看页面 同步产品中心 功能' },
        ]
      },
      {
        name: 'replenishOrder',
        label: '备货订单',
        items: [
          { name: 'replenishOrderView', desc: 'replenishOrderViewDesc', label: '备货订单查看', descc: '查询备货订单及查看备货订单详细' },
          { name: 'replenishOrderManage', desc: 'replenishOrderManageDesc', label: '备货订单管理', descc: '备货订单的新增、编辑、删除' },
          { name: 'replenishOrderCancel', desc: 'replenishOrderCancelDesc', label: '备货订单取消', descc: '备货订单取消处理' },
        ]
      },

      {
        name: 'customer',
        label: '客户',
        items: [
          { name: 'customerView', desc: 'customerViewDesc', label: '客户查看', descc: '查询客户及查看客户明细' },
          { name: 'customerCreate', desc: 'customerCreateDesc', label: '客户新增', descc: '客户的新增' },
          { name: 'customerUpdate', desc: 'customerUpdateDesc', label: '客户编辑', descc: '客户的编辑' },
          { name: 'customerDelete', desc: 'customerDeleteDesc', label: '客户删除', descc: '客户的删除' },
          { name: 'customerDistributiveOwner', desc: 'customerDistributiveOwnerDesc', label: '客户分配拥有人', descc: '分配客户给其他人' }
        ]
      },
      {
        name: 'inquiry',
        label: '询价',
        items: [
          { name: 'inquiryQuotationsManage', desc: 'inquiryQuotationsManageDesc', label: '询价单报价', descc: '查看客户的询价单，并进行报价' }
        ]
      },
      {
        name: 'deliveryRequisition',
        label: '发货申请单',
        items: [
          { name: 'deliveryRequisitionView', desc: 'deliveryRequisitionViewDesc', label: '发货申请单查看', descc: '查看发货申请单及明细' },
          { name: 'deliveryRequisitionManage', desc: 'deliveryRequisitionManageDesc', label: '发货申请单管理', descc: '申请发货，发货申请单的删除' },
        ]
      },
      // {
      //   name: 'deliveryBeforehand',
      //   label: '预发货单',
      //   items: [
      //     { name: 'deliveryBeforehandView', desc: 'deliveryBeforehandViewDesc', title: '查看预发货单', descc: '查看预发货单及明细' },
      //     { name: 'deliveryBeforehandManage', desc: 'deliveryBeforehandManageDesc', title: '预发货单管理', descc: '新增、删除预发货单' },
      //     // { name: 'deliveryBeforehandDelivery', desc: 'deliveryBeforehandDeliveryDesc', title: '预发货单发货', descc: '预发货单发货' }
      //   ]
      // },
      {
        name: 'reworkCustomer',
        label: '客户返工单',
        items: [
          { name: 'reworkCustomerView', desc: 'reworkCustomerViewDesc', label: '客户返工单', descc: '查看客户给我的返工单' }
        ]
      },
    ]
  },
  {
    name: 'rms',
    label: '租赁管理',
    show: true,
    items: [
      {
        name: 'rent',
        label: '租赁单',
        items: [
          { name: 'rentView', desc: 'rentViewDesc', label: '租赁单查看', descc: '查看租赁单' },
          {
            name: 'rentManage', desc: 'rentManageDesc', label: '租赁单管理', descc: '租赁单/清洗单的新增、编辑、删除、出库、完成'
          }
        ]
      }
    ]
  },
  {
    name: 'schedule',
    label: '日程管理',
    show: true,
    items: [
      {
        name: 'schedule',
        label: '日程',
        items: [
          { name: 'scheduleView', desc: 'scheduleViewDesc', label: '日程查看', descc: '日程查看' },
          { name: 'scheduleManage', desc: 'scheduleManageDesc', label: '日程管理', descc: '日程新增、编辑、删除、处理' }
        ]
      },
    ]
  },
  {
    name: 'saleTarget',
    label: '销售目标管理',
    show: true,
    items: [
      {
        name: 'salesTarget',
        label: '销售目标',
        items: [
          { name: 'salesTargetView', desc: 'salesTargetViewDesc', label: '销售目标查看', descc: '销售目标查看' },
          { name: 'salesTargetManage', desc: 'salesTargetManageDesc', label: '销售目标管理', descc: '销售目标新增、编辑、删除' }
        ]
      },
    ]
  },
  {
    name: 'adapter',
    label: '对接管理',
    show: true,
    items: [
      {
        name: 'adapter',
        label: '对接店铺',
        items: [
          { name: 'adapterIManage', desc: 'adapterIManageDesc', label: '国际对接', descc: '对接国际平台' },
          { name: 'adapterCManage', desc: 'adapterCManageDesc', label: '国内对接', descc: '对接国内平台' }
        ]
      },
    ]
  },
  {
    name: 'pms',
    label: '采购管理',
    show: true,
    items: [
      {
        name: 'purchase',
        label: '采购单',
        items: [
          { name: 'purchaseView', desc: 'purchaseViewDesc', label: '采购单查看', descc: '查询采购单及查看采购单明细' },
          { name: 'purchaseManage', desc: 'purchaseManageDesc', label: '采购单管理', descc: '采购单的新增、编辑、删除' },
          { name: 'purchaseRetrivePlace', desc: 'purchaseRetrivePlaceDesc', label: '采购单撤单/下单', descc: '采购单撤单和下单给供应商' },
          { name: 'purchaseReminder', desc: 'purchaseReminderDesc', label: '采购单催单', descc: '给对应供应商催单' },
          { name: 'purchaseLogView', desc: 'purchaseLogViewDesc', label: '采购单日志查看', descc: '查看采购单详细日志' }
        ]
      },
      {
        name: 'inquiry',
        label: '询价',
        items: [
          { name: 'inquiryInquiriesManage', desc: 'inquiryInquiriesManageDesc', label: '询价', descc: '向供应商询价,查看、编辑、删除我的询价单' }
        ]
      },
      {
        name: 'supplier',
        label: '供应商',
        items: [
          { name: 'supplierView', desc: 'supplierViewDesc', label: '供应商查看', descc: '查询供应商及查看供应商明细' },
          // { name: 'supplierManage', desc: 'supplierManageDesc', label: '管理供应商', descc: '供应商的增加、编辑、删除' }
        ]
      },
    ]
  },
  {
    name: 'wms',
    label: '库存管理',
    show: true,
    items: [
      {
        name: 'wmsInventory',
        label: '库存',
        items: [
          { name: 'wmsInventoryView', desc: 'wmsInventoryViewDesc', label: '库存查看', descc: '库存查看', },
          { name: 'wmsInventoryManage', desc: 'wmsInventoryManageDesc', label: '库存管理', descc: '库存盘点、导入、编辑、删除', },
          { name: 'wmsInventoryStockIn', desc: 'wmsInventoryStockInDesc', label: '手动入库', descc: '操作库存入库', },
          { name: 'wmsInventoryStockOut', desc: 'wmsInventoryStockOutDesc', label: '手动出库', descc: '操作库存出库', },
          { name: 'wmsInventoryDamage', desc: 'wmsInventoryDamageDesc', label: '库存报损', descc: '操作库存报损', },
          { name: 'wmsInventoryRework', desc: 'wmsInventoryReworkDesc', label: '库存返工', descc: '操作库存返工', },
          { name: 'wmsInventoryAllocateIn', desc: 'wmsInventoryAllocateInDesc', label: '申请调入', descc: '操作申请调入', },
          { name: 'wmsInventoryAllocateOut', desc: 'wmsInventoryAllocateOutDesc', label: '申请调出', descc: '操作申请调出', },
          { name: 'wmsInventoryPickShelf', desc: 'wmsInventoryPickShelfDesc', label: '拣货出库', descc: '从仓库的库位中拿取货品', },
          { name: 'wmsInventoryPushShelf', desc: 'wmsInventoryPushShelfDesc', label: '上架入库', descc: '把货品放入仓库的库位中', },
          { name: 'wmsInventoryStockInOut', desc: 'wmsInventoryStockInOutDesc', label: '出入库单管理', descc: '查看库存的出库单，入库单', },
          { name: 'wmsInventorySnapshoots', desc: 'wmsInventorySnapshootsDesc', label: '库存结存', descc: '查看库存每月自动结存数据', },

        ]
      },
      {
        name: 'wmsAllocate',
        label: '调拨单',
        items: [
          { name: 'wmsAllocateView', desc: 'wmsAllocateViewDesc', label: '调拨单查看', descc: '查看调拨单', },
          { name: 'wmsAllocateManage', desc: 'wmsAllocateManageDesc', label: '调拨单管理', descc: '调拨单编辑、删除', },
          { name: 'wmsAllocateVerify', desc: 'wmsAllocateVerifyDesc', label: '调拨单审核', descc: '受理方是否同意申请调出', },

        ]
      },
      {
        name: 'wmsDamage',
        label: '报损单',
        items: [
          { name: 'wmsDamageView', desc: 'wmsDamageViewDesc', label: '报损单查看', descc: '查看报损单', },
          { name: 'wmsDamageManage', desc: 'wmsDamageManageDesc', label: '报损单管理', descc: '报损单编辑、删除', },
          { name: 'wmsDamageVerify', desc: 'wmsDamageVerifyDesc', label: '报损单审核', descc: '审核报损单', },
        ]
      }
    ]
  },
  {
    name: 'pdm',
    label: '产品中心',
    show: true,
    items: [
      {
        name: 'productMy',
        label: '我的产品',
        items: [
          { name: 'productView', desc: 'productViewDesc', label: '产品查看(不含供应商信息)', descc: '查询及查看产品(不含供应商信息)' },
          { name: 'productManage', desc: 'productManageDesc', label: '管理产品', descc: '产品的新增、编辑' },
          { name: 'productManageCraftwork', desc: 'productManageCraftworkDesc', label: '管理产品制作工艺', descc: '编辑产品的制作工艺' },
          { name: 'productDelete', desc: 'productDeleteDesc', label: '删除产品', descc: '产品的删除' },
          { name: 'productVerify', desc: 'productVerifyDesc', label: '审核产品', descc: '产品的审核(审核后才能用该产品做单)' },
          { name: 'mmsProductView', desc: 'mmsProductViewDesc', label: '查看配料', descc: '查看产品配料信息' },
          { name: 'mmsProductIngredient', desc: 'mmsProductIngredientDesc', label: '配料', descc: '给产品配料' },
          { name: 'mesProductView', desc: 'mesProductViewDesc', label: '查看工序', descc: '查看产品工序信息' },
          { name: 'mesProductDistributePhases', desc: 'mesProductDistributePhasesDesc', label: '配工序', descc: '给产品配工序' }
        ]
      },
      {
        name: 'productSupplier',
        label: '供应商产品',
        items: [
          { name: 'supplierProductView', desc: 'supplierProductViewDesc', label: '供应商产品查看', descc: '查看供应商提供的产品' }
        ]
      },
      {
        name: 'productQuote',
        label: '报价',
        items: [
          { name: 'quoteToCustomerView', desc: 'quoteToCustomerViewDesc', label: '报价查看', descc: '查看给客户的报价' },
          { name: 'quoteToCustomerManage', desc: 'quoteToCustomerManageDesc', label: '产品共享', descc: '给客户报价增加、编辑、删除' }
        ]
      }
    ]
  },
  {
    name: 'mes',
    label: '生产管理',
    show: true,
    items: [
      {
        name: 'mesOrder',
        label: '生产订单',
        items: [
          { name: 'mesOrderView', desc: 'mesOrderViewDesc', label: '查看订单', descc: '查看订单' },
          { name: 'mesOrderEdit', desc: 'mesOrderEditDesc', label: '编辑订单', descc: '编辑订单的自定义属性信息' },
          { name: 'mesOrderDispatch', desc: 'mesOrderDispatchDesc', label: '派单', descc: '生成工单并派工序' },
          { name: 'mesOrderCancel', desc: 'mesOrderCancelDesc', label: '取消', descc: '取消订单，同时相关联的工单也标记取消，后续不再生产' },
          { name: 'mesOrderStop', desc: 'mesOrderStopDesc', label: '暂停生产', descc: '暂停订单的生产' },
          { name: 'mesOrderReProcess', desc: 'mesOrderReProcessDesc', label: '恢复生产', descc: '恢复暂停生产的订单' },
          { name: 'mesOrderReDispatch', desc: 'mesOrderReDispatchDesc', label: '重新派单', descc: '订单重新进行派单' },
          { name: 'mesOrderPhasesManage', desc: 'mesOrderPhasesManageDesc', label: '工序管理', descc: '对订单的工序增加、删除、修改' }
        ]
      },
      {
        name: 'mesWorkOrder',
        label: '生产工单',
        items: [
          { name: 'mesWorkOrderView', desc: 'mesWorkOrderViewDesc', label: '查看工单', descc: '查看工单及详细情况' },
          { name: 'mesWorkOrderEdit', desc: 'mesWorkOrderEditDesc', label: '编辑', descc: '编辑工单和工单号' },
          // { name: 'mesWorkOrderReceive', desc: 'mesWorkOrderReceiveDesc', label: '接收', descc: '接收工单到自己管理的工序' },
          { name: 'mesWorkOrderDistribute', desc: 'mesWorkOrderDistributeDesc', label: '派发', descc: '派发给工人生产' },
          { name: 'mesWorkOrderCheck', desc: 'mesWorkOrderCheckDesc', label: '尾查', descc: '成品尾查，通过或返工' },
          { name: 'mesTrackingView', desc: 'mesTrackingViewDesc', label: '跟单', descc: '跟踪订单、工单、人员情况' },
          { name: 'mesWorkOrderProcessingFinish', desc: 'mesWorkOrderProcessingFinishDesc', label: '生产完成', descc: '将工单生产完成' }
        ]
      },
      {
        name: 'mesRework',
        label: '返工记录',
        items: [
          { name: 'mesReworkView', desc: 'mesReworkViewDesc', label: '返工记录查看', descc: '查看返工记录' },
          { name: 'mesReworkFinish', desc: 'mesReworkFinishDesc', label: '返工完成', descc: '返工完成' }
        ]
      },
      {
        name: 'mesRecord',
        label: '生产记录',
        items: [
          { name: 'mesRecordView', desc: 'mesRecordViewDesc', label: '查看生产记录', descc: '查看工人的生产记录' },
          { name: 'mesRecordManage', desc: 'mesRecordManageDesc', label: '管理生产记录', descc: '编辑工时，删除生产记录' },
          { name: 'mesRecordScan', desc: 'mesRecordScanDesc', label: '扫描生产', descc: '扫描生产、结束生产' },
          { name: 'mesRecordHalfCheck', desc: 'mesRecordHalfCheckDesc', label: '半检', descc: '半检' },
          { name: 'mesRecordAddRemark', desc: 'mesRecordAddRemarkDesc', label: '添加备注', descc: '添加、编辑生产记录的备注信息' },
          { name: 'mmsInventoryOutProduce', desc: 'mmsInventoryOutProduceDesc', label: '库存减料', descc: '生产助手里面物料库存减料' },
        ]
      },
      {
        name: 'mesHang',
        label: '挂单记录',
        items: [
          { name: 'mesHangView', desc: 'mesHangViewDesc', label: '挂单记录查看', descc: '查看挂单记录' },
          { name: 'mesHangFinish', desc: 'mesHangViewFinishDesc', label: '挂单完成', descc: '挂单完成' }
        ]
      },
      {
        name: 'mesWorker',
        label: '工人',
        items: [
          { name: 'mesWorkerView', desc: 'mesWorkerViewDesc', label: '查看工人', descc: '查看工人' },
          { name: 'mesWorkerManage', desc: 'mesWorkerManageDesc', label: '管理工人', descc: '工人的编辑、删除、失效' }
        ]
      }
    ]
  },
  {
    name: 'mms',
    label: '物料管理',
    show: true,
    items: [
      {
        name: 'mmsPendingRequisitions',
        label: '待发料',
        items: [
          { name: 'mmsPendingRequisitionsView', desc: 'mmsPendingRequisitionsViewDesc', label: '待发料', descc: '查看待发料的工单、采购单' },
          // { name: 'mmsPendingRequisitionsPicking', desc: 'mmsPendingRequisitionsPickingDesc', label: '生成发料单', descc: '操作工单、采购单生成发料单' },
          { name: 'mmsPendingRequisitionsPickingAndDirectFeed', desc: 'mmsPendingRequisitionsPickingAndDirectFeedDesc', label: '生成发料单并发料', descc: '操作工单生成发料单并发料' },
          { name: 'mmsPendingRequisitionsCreateProcure', desc: 'mmsPendingRequisitionsCreateProcureDesc', label: '生成采购单', descc: '操作生成物料采购单' }
        ]
      },
      {
        name: 'mmsSupplier',
        label: '物料供应商',
        items: [
          { name: 'mmsSupplierView', desc: 'mmsSupplierDesc', label: '查看供应商', descc: '查看供应商' },
          { name: 'mmsSupplierManage', desc: 'mmsSupplierManageDesc', label: '管理供应商', descc: '供应商的增加、编辑、删除' }
        ]
      },
      {
        name: 'mmsMaterial',
        label: '物料',
        items: [
          { name: 'mmsMaterialView', desc: 'mmsMaterialViewDesc', label: '查看物料', descc: '查看物料' },
          { name: 'mmsMaterialViewPurchaseInfo', desc: 'mmsMaterialViewPurchaseInfoDesc', label: '查看采购信息', descc: '查看采购价、供应商' },
          { name: 'mmsMaterialManage', desc: 'mmsMaterialManageDesc', label: '管理物料', descc: '增加、编辑、删除物料' }
        ]
      },

      {
        name: 'mmsInventory',
        label: '库存',
        items: [
          { name: 'mmsInventoryView', desc: 'mmsInventoryViewDesc', label: '查看库存', descc: '查看库存' },
          { name: 'mmsInventoryManage', desc: 'mmsInventoryManageDesc', label: '管理库存', descc: '编辑、删除、盘点库存' },
          { name: 'mmsInventoryEditPrice', desc: 'mmsInventoryEditPriceDesc', label: '管理库存单价', descc: '编辑物料库存单价' },
          { name: 'mmsInventoryApplyPurchase', desc: 'mmsInventoryApplyPurchaseDesc', label: '申请采购', descc: '从库存申请生成采购单' },
          { name: 'mmsInventoryAllocate', desc: 'mmsInventoryAllocateDesc', label: '库存调拨', descc: '对库存物料进行调拨，并管理调拨' },
          { name: 'mmsInventoryInOutManage', desc: 'mmsInventoryInOutManageDesc', label: '出入库单管理', descc: '查看库存的出库单，入库单' },
          { name: 'mmsInventorySnapshoot', desc: 'mmsInventorySnapshootDesc', label: '库存结存', descc: '查看库存每月自动结存数据' },
          { name: 'mmsInventoryCashs', desc: 'mmsInventoryCashsDesc', label: '超发余量', descc: '查看库存超发余量、并操作退仓' },
        ]
      },
      {
        name: 'mmsRequisition',
        label: '发料单',
        items: [
          { name: 'mmsRequisitionView', desc: 'mmsRequisitionViewDesc', label: '查看发料单', descc: '查看发料单' },
          { name: 'mmsRequisitionManage', desc: 'mmsRequisitionManageDesc', label: '管理发料单', descc: '编辑、删除发料单' },
          { name: 'mmsRequisitionRaw', desc: 'mmsRequisitionRawDesc', label: '发料', descc: '发料单发料' }
        ]
      },
      {
        name: 'mmsAccountiMaterial',
        label: '用料核算',
        items: [
          { name: 'mmsAccountiMaterial', desc: 'mmsAccountiMaterialDesc', label: '用料核算', descc: '订单、采购单进行用料核算' }
        ]
      },
      {
        name: 'mmsProcure',
        label: '采购单',
        items: [
          { name: 'mmsProcureView', desc: 'mmsProcureViewDesc', label: '查看采购单', descc: '查看采购单' },
          { name: 'mmsProcureManage', desc: 'mmsProcureManageDesc', label: '管理采购单', descc: '新增、编辑、删除采购单' },
          { name: 'mmsProcurePlace', desc: 'mmsProcurePlaceDesc', label: '下单', descc: '采购单下单' },
          { name: 'mmsProcureReceive', desc: 'mmsProcureReceiveDesc', label: '采购收料', descc: '对采购单进行收料' },
          { name: 'mmsProcureQuality', desc: 'mmsProcureQualityDesc', label: '采购收料后质检', descc: '对采购单收料后进行质检' }
        ]
      },
      {
        name: 'mmsReturnedMaterial',
        label: '退料单',
        items: [
          { name: 'mmsReturnedMaterialView', desc: 'mmsReturnedMaterialViewDesc', label: '查看退料单', descc: '查看退料单' },
          { name: 'mmsReturnedMaterialManage', desc: 'mmsReturnedMaterialManageDesc', label: '管理退料单', descc: '新增、编辑、删除退料单' },
          { name: 'mmsReturnedMaterialVerify', desc: 'mmsReturnedMaterialVerifyDesc', label: '审核', descc: '退料单审核' },
          { name: 'mmsReturnedMaterialFinish', desc: 'mmsReturnedMaterialFinishDesc', label: '退料出库', descc: '对退料单进行出库' }
        ]
      }
    ]
  },
  {
    name: 'lms',
    label: '收发货管理',
    show: true,
    items: [
      {
        name: 'receive',
        label: '收货',
        items: [
          { name: 'receiveView', desc: 'receiveViewDesc', label: '收货', descc: '收货' },
          { name: 'receiveReceiveQuality', desc: 'receiveReceiveQualityDesc', label: '收货并质检', descc: '收货并质检通过' },
          { name: 'receiveReceiveQualityPush', desc: 'receiveReceiveQualityPushDesc', label: '收货并入库', descc: '收货并质检通过并入库' },
          { name: 'receiveReceiveQualityDelivery', desc: 'receiveReceiveQualityDeliveryDesc', label: '收货并发货', descc: '收货并发货' },
          { name: 'receiveQuality', desc: 'receiveQualityDesc', label: '质检', descc: '质检通过或返工' },
          { name: 'receiveQualityPush', desc: 'receiveQualityPushDesc', label: '质检并上架', descc: '质检通过并上架' },
          { name: 'receiveQualityDelivery', desc: 'receiveQualityDeliveryDesc', label: '质检并发货', descc: '质检通过并发货' },
        ]
      },
      {
        name: 'deliver',
        label: '发货',
        items: [
          { name: 'deliverApplyTracking', desc: 'deliverApplyTrackingDesc', label: '申请运单号', descc: '申请运单号' },
          { name: 'deliverView', desc: 'deliverViewDesc', label: '发货单查看', descc: '查询发货单及发货单明细' },
          { name: 'deliverAction', desc: 'deliverActionDesc', label: '发货', descc: '发货' },
          { name: 'deliverUploadTracking', desc: 'deliverUploadTrackingDesc', label: '发货单跟新跟踪号', descc: '发货单倒入跟踪号、上传跟踪号、添加跟踪号、重新获取跟踪号' },
          { name: 'deliveryRequisitionDelivery', desc: 'deliveryRequisitionDeliveryDesc', label: '发货申请单 发货', descc: '发货申请单的发货' }
        ]
      },
      {
        name: 'requestResponse',
        label: '发货反馈',
        items: [
          { name: 'requestResponseExpress', desc: 'requestResponseExpressDesc', label: '快递', descc: '查看快递的发货反馈' },
          { name: 'requestResponseAgent', desc: 'requestResponseAgentDesc', label: '货代', descc: '查看货代的发货反馈' },
        ]
      },
    ]
  },
  {
    name: 'fnReport',
    label: '财务•报表',
    show: true,
    items: [
      {
        name: 'settlement',
        label: '财务',
        items: [
          { name: 'settlementManageCustomer', desc: 'settlementManageCustomerDesc', label: '客户账单', descc: '给客户拉账单及管理客户账单' },
          { name: 'settlementManageSupplier', desc: 'settlementManageSupplierDesc', label: '采购账单', descc: '给供应商拉账单及管理供应商账单' },
          { name: 'settlementManageDelivery', desc: 'settlementManageDeliveryDesc', label: '发货账单', descc: '发货账单管理' },
          { name: 'mmsSettlementManageProcure', desc: 'mmsSettlementManageProcureDesc', label: '物料采购账单', descc: '物料采购账单管理' },
          { name: 'mesSettlementsOrders', desc: 'mesSettlementsOrdersDesc', label: '工厂订单账单', descc: '给工厂拉账单及管理工厂账单' },
          { name: 'mesSalary', desc: 'mesSalaryDesc', label: '工人工资单', descc: '工人工资单管理' },
          { name: 'saleSettlement', desc: 'saleSettlementDesc', label: '业绩结算', descc: '子账户业绩结算' },
          { name: 'bargainFinanceVerify', desc: 'bargainFinanceVerifyDesc', label: '订单财务审核', descc: '标记订单财务审核' },
          { name: 'bargainDeliveryVerify', desc: 'bargainDeliveryVerifyDesc', label: '订单欠款发货审核', descc: '订单欠款审核通过后可发货' },
          { name: 'customerBalanceVerify', desc: 'customerBalanceVerifyDesc', label: '客户充值审核', descc: '审核后的充值记录不能编辑删除' },
          { name: 'reportMonthSettlement', desc: null, label: '月度结账', descc: null },
        ]
      },
      {
        name: 'report',
        label: '报表',
        items: [
          { name: 'reportView', desc: null, label: '所有报表的查看权限', descc: null },
        ]
      },
      // {
      //   name: 'reportOms',
      //   label: '报表-订单管理',
      //   items: [
      //     { name: 'omsPaymentDetail', desc: null, label: '收款明细报表', descc: null },
      //     { name: 'omsWholesaleCustomerRanking', desc: null, label: '大客户排名报表', descc: null },
      //     { name: 'reportOmsProductSaleRanking', desc: null, label: '产品销售排名报表', descc: null },
      //     { name: 'reportOmsSalePerformance', desc: null, label: '销售业绩报表', descc: null },
      //     { name: 'reportOmsSaleLineChart', desc: null, title: '日报月报年报', descc: null },
      //   ]
      // },
      // {
      //   name: 'reportPms',
      //   label: '报表-外采管理',
      //   items: [
      //     { name: 'reportPmsPurchaseDetail', desc: null, label: '采购明细报表', descc: null }
      //   ]
      // },
      // {
      //   name: 'reportMes',
      //   label: '报表-生产管理',
      //   items: [
      //     { name: 'mesQa', desc: null, label: '尾查报表', descc: null }
      //   ]
      // },
      // {
      //   name: 'reportWms',
      //   label: '报表-库存管理',
      //   items: [
      //     { name: 'wmsInventoryCount', desc: null, label: '库存统计报表', descc: null }
      //   ]
      // }
    ]
  },
  {
    name: 'mall',
    label: '赢小店管理',
    show: true,
    items: [
      {
        name: 'mall',
        label: '赢小店',
        items: [
          { name: 'mallManage', desc: 'mallManageDesc', label: '赢小店管理', descc: '' },
        ]
      },
    ]
  }
]

export default {
  currentTenant() {
    // console.log("=====permit", ls.session('TENANT'))
    return ls.session('TENANT')
  },
  currentUser() {
    return ls.session('USER')
  },
  edition() {
    if (this.currentTenant()) {
      return this.currentTenant().edition
    }
    return null
  },
  createOrderFixShopDF() {
    if (this.currentUser() && this.currentUser().admin == true) {
      return false
    }
    if (this.currentTenant() && this.currentTenant().config.createOrderFixShop == true) {
      return true
    }
    return false
  },
  isFreeEdition() {
    if (this.currentTenant() && ['af', 'bf'].includes(this.currentTenant().edition)) {
      return true
    }
    return false
  },
  isChargeEdition() {
    if (this.currentTenant() && ['charge'].includes(this.currentTenant().edition)) {
      return true
    }
    return false
  },

  extendModels() {
    if (this.currentTenant()) {
      return JSON.parse(this.currentTenant().charge.extendModelNew)
    }
    return []
  },
  //
  mesUserAuths() {
    return ls.session('MESUSERAUTHS')
  },
  mesAuthPhaseIds() {
    return ls.session('MESAUTHPHASEIDS')
  },
  //
  mmsUserAuths() {
    return ls.session('MMSUSERAUTHS')
  },
  mmsAuthSubjuctIds() {
    return ls.session('MMSAUTHSUNJECTIDS')
  },
  //
  wmsViewShopIds() {
    if (this.currentUser() != null && this.extendModels().includes("wms")) {
      const permissions = this.currentUser().permissions || [];
      if (permissions.length != 0) {
        const inventoryViewObj = permissions.find(
          (p) => p.permission == "inventoryView"
        );
        return JSON.parse(
          inventoryViewObj.shops || "'[]'"
        )
      }
      return []
    }
    return []
  },
  wmsManageShopIds() {
    if (this.currentUser() != null && this.extendModels().includes("wms")) {
      const permissions = this.currentUser().permissions || [];
      if (permissions.length != 0) {
        const inventoryManageObj = permissions.find(
          (p) => p.permission == "inventoryManage"
        );
        return JSON.parse(
          inventoryManageObj.shops || "'[]'"
        )
      }
      return []
    }
    return []
  },
  //
  actionsJson() {
    if (this.currentUser() != null) {
      const userAuthJY = JSON.parse(this.currentUser().actionsJson)
      let allUserAuth = userAuthJY
      // mms
      if (this.extendModels().includes('mms') && this.mmsUserAuths() != null) {
        allUserAuth = allUserAuth.concat(this.mmsUserAuths())
      }
      // mes
      if (this.extendModels().includes('mes') && this.mesUserAuths() != null) {
        allUserAuth = allUserAuth.concat(this.mesUserAuths())
      }
      return allUserAuth
    }
    return []
  },
  canActions(action) {
    if (this.currentUser() && this.currentUser().admin) {
      return true
    } else {
      return this.actionsJson().includes(action)
    }
  },
  canActionsChargeEdition(action) {
    if (!this.isFreeEdition()) {
      return this.canActions(action)
    } else {
      return false
    }
  },
  //isFreeEdition
  // canActionsFreeEdition() {
  //   if (['af', 'bf'].includes(this.currentTenant().edition)) {
  //     return true
  //   } else {
  //     return false
  //   }
  // },
  canActionsConfigDealType(dealType) {
    if (this.currentTenant() == null) {
      return false
    }
    const currentTenantConfigDealTypes = JSON.parse(this.currentTenant().config.dealType)
    if (currentTenantConfigDealTypes.includes(dealType)) {
      return true
    } else {
      return false
    }
  },
  permissions() {
    let permissions = JSON.parse(JSON.stringify(permissions_all))
    // console.log("==", permissions[0].items)
    if (!this.extendModels().includes('mall')) {
      permissions = permissions.filter(permission => permission.name !== 'mall')
    }
    //
    if (!this.extendModels().includes('wms')) {
      permissions = permissions.filter(permission => permission.name !== 'wms')
      //　工作台
      let dashboardIndex = permissions.findIndex(p => p.name == "dashboard")
      let dashboardWmsIndex = permissions[dashboardIndex].items.findIndex(item => item.name == "dashboardWms")
      permissions[dashboardIndex].items.splice(dashboardWmsIndex, 1)
      // 收货质检并上架receiveReceiveQualityPush  质检并上架receiveQualityPush
      let lmsIndex = permissions.findIndex(p => p.name == "lms")
      let lmsReceiveIndex = permissions[lmsIndex].items.findIndex(item => item.name == "receive")
      permissions[lmsIndex].items[lmsReceiveIndex].items = permissions[lmsIndex].items[lmsReceiveIndex].items.filter(i => i.name !== 'receiveReceiveQualityPush' && i.name != 'receiveQualityPush')


      // //  财务报表
      // const reportIndex = permissions.findIndex(p => p.name == "fnReport")
      // permissions[reportIndex].items = permissions[reportIndex].items.filter(i => i.name !== 'reportWms')
    }
    if (this.extendModels().includes('wms') && !this.extendModels().includes('rms')) {
      //　工作台
      const dashboardIndex = permissions.findIndex(p => p.name == "dashboard")
      const dashboardWmsIndex = permissions[dashboardIndex].items.findIndex(item => item.name == "dashboardWms")
      permissions[dashboardIndex].items[dashboardWmsIndex].items = permissions[dashboardIndex].items[dashboardWmsIndex].items.filter(i => i.name != 'wmsInventorySearchSchedule')

    }
    if (!this.extendModels().includes('mes')) {
      permissions = permissions.filter(permission => permission.name !== 'mes')
      //工作台
      const dashboardIndex = permissions.findIndex(p => p.name == "dashboard")
      const dashboardMesIndex = permissions[dashboardIndex].items.findIndex(item => item.name == "dashboardMes")
      permissions[dashboardIndex].items.splice(dashboardMesIndex, 1)
      // 产品
      const pdmIndex = permissions.findIndex(p => p.name == "pdm")
      const pdmProductMyIndex = permissions[pdmIndex].items.findIndex(item => item.name == "productMy")
      permissions[pdmIndex].items[pdmProductMyIndex].items = permissions[pdmIndex].items[pdmProductMyIndex].items.filter(i => i.name !== 'mesProductView' && i.name !== 'mesProductDistributePhases')
      // 财务报表
      const reportIndex = permissions.findIndex(p => p.name == "fnReport")
      const reportSettlementIndex = permissions[reportIndex].items.findIndex(item => item.name == "settlement")
      permissions[reportIndex].items[reportSettlementIndex].items = permissions[reportIndex].items[reportSettlementIndex].items.filter(i => i.name !== 'mesSalary' && i.name !== "mesSettlementsOrders")
      // permissions[reportIndex].items = permissions[reportIndex].items.filter(i => i.name !== 'reportMes')
    }
    if (!this.extendModels().includes('mms')) {
      permissions = permissions.filter(permission => permission.name !== 'mms')
      permissions[0].items[0].items = permissions[0].items[0].items.filter(item => item.name !== 'globalMaterialPrice')

      //　工作台
      const dashboardIndex = permissions.findIndex(p => p.name == "dashboard")
      const dashboardMmsIndex = permissions[dashboardIndex].items.findIndex(item => item.name == "dashboardMms")
      permissions[dashboardIndex].items.splice(dashboardMmsIndex, 1)
      // 产品
      const pdmIndex = permissions.findIndex(p => p.name == "pdm")
      const pdmProductMyIndex = permissions[pdmIndex].items.findIndex(item => item.name == "productMy")
      permissions[pdmIndex].items[pdmProductMyIndex].items = permissions[pdmIndex].items[pdmProductMyIndex].items.filter(i => i.name !== 'mmsProductView' && i.name !== 'mmsProductIngredient')
      //  财务报表
      const reportIndex = permissions.findIndex(p => p.name == "fnReport")
      const reportSettlementIndex = permissions[reportIndex].items.findIndex(item => item.name == "settlement")
      permissions[reportIndex].items[reportSettlementIndex].items = permissions[reportIndex].items[reportSettlementIndex].items.filter(i => i.name !== 'mmsSettlementManageProcure')
      // permissions[reportIndex].items = permissions[reportIndex].items.filter(i => i.name !== 'reportMms')
      //
      const mesIndex = permissions.findIndex(p => p.name == "mes")
      if (mesIndex != -1) {
        const mesRecordIndex = permissions[mesIndex].items.findIndex(item => item.name == "mesRecord")
        permissions[mesIndex].items[mesRecordIndex].items = permissions[mesIndex].items[mesRecordIndex].items.filter(i => i.name !== 'mmsInventoryOutProduce')
      }


    }
    if (!this.extendModels().includes('rms')) {
      permissions = permissions.filter(permission => permission.name !== 'rms')
    }
    if (!this.extendModels().includes('schedule')) {
      permissions = permissions.filter(permission => permission.name !== 'schedule')
    }
    if (!this.extendModels().includes('salesTarget')) {
      permissions = permissions.filter(permission => permission.name !== 'salesTarget')
    }
    if (!this.extendModels().includes('adapterI') && !this.extendModels().includes('adapterC')) {
      permissions = permissions.filter(permission => permission.name !== 'adapter')
    } else {
      let adapterIndex = permissions.findIndex(p => p.name == "adapter")
      if (!this.extendModels().includes('adapterI')) {
        permissions[adapterIndex].items = permissions[adapterIndex].items.filter(i => i.name != 'adapterIManage')
      }
      if (!this.extendModels().includes('adapterC')) {
        permissions[adapterIndex].items = permissions[adapterIndex].items.filter(i => i.name != 'adapterCManage')
      }
    }

    // 发货反馈
    let lmsIndex = permissions.findIndex(p => p.name == "lms")
    let lmsRequestResponseIndex = permissions[lmsIndex].items.findIndex(item => item.name == "requestResponse")
    if (!this.extendModels().includes('lmsE') && !this.extendModels().includes('lmsC')) {
      permissions[lmsIndex].items = permissions[lmsIndex].items.filter(i => i.name != 'requestResponse')
    } else {
      if (!this.extendModels().includes('lmsE')) {
        permissions[lmsIndex].items[lmsRequestResponseIndex].items = permissions[lmsIndex].items[lmsRequestResponseIndex].items.filter(i => i.name != 'requestResponseExpress')
      }
      if (!this.extendModels().includes('lmsC')) {
        permissions[lmsIndex].items[lmsRequestResponseIndex].items = permissions[lmsIndex].items[lmsRequestResponseIndex].items.filter(i => i.name != 'requestResponseAgent')
      }
    }
    // 财务报表 欠款可发货审核权限
    if (!this.currentTenant().config.deliveryStrict) {
      const reportIndex = permissions.findIndex(p => p.name == "fnReport")
      const reportSettlementIndex = permissions[reportIndex].items.findIndex(item => item.name == "settlement")
      permissions[reportIndex].items[reportSettlementIndex].items = permissions[reportIndex].items[reportSettlementIndex].items.filter(i => i.name !== 'bargainDeliveryVerify')
    }
    return permissions
  },
  sysPermits(sys) {
    const currentSysPermissions = this.permissions().find(p => p.name === sys)
    let permits = []
    if (currentSysPermissions != null) {
      for (const item of currentSysPermissions.items) {
        permits = permits.concat(item.items.map(i => i.name))
      }
    }
    return permits
  },
}

